import React from "react";
import { Lightning, VideoCamera, CursorClick, ArrowSquareOut, LockSimple, CreditCard, TextT } from "@phosphor-icons/react";
import { Switch } from "@/components/ui/switch";
import { Field, ToggleRow, inputCls, isUrl } from "./EditorBits";

// Passo 6 do construtor de funil: Vídeo + Compra direta com redirecionamento
export const DirectBuyStepCard = ({ form, setForm, watchPct }) => {
  const on = !!form.direct_buy_enabled;
  const set = (patch) => setForm({ ...form, ...patch });
  const badUrl = on && form.redirect_url && !isUrl(form.redirect_url);

  return (
    <div className={`rounded-2xl p-[1px] transition-colors ${on ? "bg-gradient-to-br from-[#FFB30F]/70 via-[#FFB30F]/15 to-transparent" : "bg-white/[0.08]"}`} data-testid="funnel-step6-card">
      <div className="rounded-2xl bg-[#121418] p-5 sm:p-6">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-start gap-3 min-w-0">
            <span className="w-10 h-10 rounded-xl bg-[#FFB30F]/10 text-[#FFB30F] flex items-center justify-center shrink-0"><Lightning size={20} weight="fill" /></span>
            <div className="min-w-0">
              <div className="label-caps flex flex-wrap items-center gap-2">Passo 6 · Vídeo + Compra direta <span className="rounded-full bg-[var(--accent)] text-black text-[9px] font-black px-2 py-0.5">OPCIONAL</span></div>
              <div className="text-xs sm:text-sm text-white/60 mt-1">Transforma este link em uma página com vídeo e botão de compra logo abaixo. Após o pagamento, o cliente é redirecionado para o seu link.</div>
            </div>
          </div>
          <Switch checked={on} onCheckedChange={(v) => set({ direct_buy_enabled: v })} data-testid="funnel-step6-active-toggle" />
        </div>

        {on && (
          <div className="mt-5 space-y-4" data-testid="funnel-step6-fields">
            <Field label="Link de redirecionamento após pagamento *" error={badUrl ? "Use um link começando com https://" : undefined} hint="Ex: área de membros, grupo VIP, Google Drive, página de obrigado.">
              <div className="relative">
                <ArrowSquareOut size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" />
                <input className={`${inputCls} pl-11`} value={form.redirect_url || ""} onChange={(e) => set({ redirect_url: e.target.value })} placeholder="https://seusite.com/obrigado" data-testid="funnel-step6-redirect-url" />
              </div>
            </Field>
            <div className="grid md:grid-cols-2 gap-4">
              <Field label="Vídeo desta etapa (opcional)" hint="Vazio = usa o vídeo do Passo 1.">
                <div className="relative">
                  <VideoCamera size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" />
                  <input className={`${inputCls} pl-11`} value={form.direct_buy_video_url || ""} onChange={(e) => set({ direct_buy_video_url: e.target.value })} placeholder="https://youtube.com/..." data-testid="funnel-step6-video-url" />
                </div>
              </Field>
              <Field label="Texto do botão de compra">
                <div className="relative">
                  <CursorClick size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" />
                  <input className={`${inputCls} pl-11`} value={form.direct_buy_button_text || ""} onChange={(e) => set({ direct_buy_button_text: e.target.value })} placeholder="Comprar agora" maxLength={60} data-testid="funnel-step6-button-text" />
                </div>
              </Field>
            </div>
            <Field label="Chamada abaixo do título (opcional)">
              <div className="relative">
                <TextT size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" />
                <input className={`${inputCls} pl-11`} value={form.direct_buy_headline || ""} onChange={(e) => set({ direct_buy_headline: e.target.value })} placeholder="Assista e garanta sua vaga" maxLength={300} data-testid="funnel-step6-headline" />
              </div>
            </Field>
            <ToggleRow icon={LockSimple} title={`Travar botão até assistir ${watchPct}%`} desc="Usa a % configurada no Passo 1. Desligado = botão aparece logo abaixo do vídeo." checked={!!form.direct_buy_require_watch} onChange={(v) => set({ direct_buy_require_watch: v })} testid="funnel-step6-watch-toggle" />
            <ToggleRow icon={CreditCard} title="Aceitar cartão de crédito" desc="Pix sempre ativo. Cartão via checkout seguro Stripe." checked={form.direct_buy_accept_card !== false} onChange={(v) => set({ direct_buy_accept_card: v })} testid="funnel-step6-card-toggle" />
            <div className="text-xs text-white/50 rounded-xl border border-white/[0.08] bg-white/[0.02] px-4 py-3">Os <b className="text-white/80">planos do Passo 5</b> viram as opções de compra (com 1 plano, o botão vai direto ao checkout). Os acessos à área de membros continuam sendo criados e enviados por e-mail.</div>
          </div>
        )}
      </div>
    </div>
  );
};
